import script from "./UserNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNavigation.vue?vue&type=script&setup=true&lang=js"

import "./UserNavigation.vue?vue&type=style&index=0&id=eb829c2c&lang=css"

const __exports__ = script;

export default __exports__